<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-right">
        &copy; Bản quyền thuộc Công ty Cổ phần VSI.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
